import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Tooltip,
  Stack,
  useMediaQuery,
} from '@mui/material';
import { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import { setError } from '../../services/Errors';
import { getPlaytime, removePlaytime } from '../../services/Playtime';
import { convertMinsToHrsMins } from '../../utils/Math';
import { getDateFromSeconds } from '../../utils/Date';
import EditModal from './EditModal';
import { hasAccountAlias } from '../../services/Account';

const MyHours = ({ user }) => {
  const [playtime, setPlaytime] = useState([]);
  const [deleteBtn, setDeleteBtn] = useState({ index: null, row: {} });
  const [edit, setEdit] = useState({ modal: false });
  const [isAliasUser, setIsAliasUser] = useState(false);

  const mobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    const fetchData = async () => {
      let uid = user.uid;
      await hasAccountAlias(uid).then((alias) => {
        if (alias) {
          uid = alias;
          setIsAliasUser(true);
        }
      });

      if (JSON.parse(localStorage.getItem('summaryObj'))?.expires > +new Date()) {
        setPlaytime(JSON.parse(localStorage.getItem('summaryObj'))?.playtime);
      } else {
        getPlaytime(uid)
          .then((response) => {
            setPlaytime(response);
            localStorage.setItem(
              'summaryObj',
              JSON.stringify({ playtime: response, expires: new Date().setDate(new Date().getDate() + 7) })
            );
          })
          .catch((error) => setError(uid, error.message));
      }
    };
    if (user.uid) fetchData();
  }, [user, edit.id]);

  const getPlaytimeTotal = (playtime) => {
    const minutes = playtime.reduce((sum, current) => sum + parseInt(current?.hours) * 60 + parseInt(current?.minutes), 0);
    const playtimeObj = convertMinsToHrsMins(minutes);
    return `${playtimeObj?.hours ?? 0} timer og ${playtimeObj.minutes ?? 0} minutter`;
  };

  const deletePlaytime = (index, row) => {
    if (!isAliasUser) {
      if (deleteBtn.index === index) {
        removePlaytime(row)
          .then(() => {
            localStorage.removeItem('summaryObj');
            setPlaytime([...playtime].filter((playtime) => playtime.id !== row.id));
          })
          .catch((error) => setError(user.phoneNumber, error.message));
      } else {
        setDeleteBtn({ index, row });
      }
    }
  };

  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Veldig bra! Du har registrert <strong>{getPlaytimeTotal(playtime)}</strong> med fotballyst!
      </Typography>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Dato</TableCell>
            <TableCell>Tid</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {playtime.map((row, index) => (
            <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">
                {getDateFromSeconds(row?.date?.seconds)}
              </TableCell>
              <TableCell>{row.hours + ' timer ' + row.minutes + ' minutter'}</TableCell>
              <TableCell>
                {!isAliasUser && (
                  <Stack direction={mobile ? 'column' : 'row'} spacing={mobile ? 0 : 2}>
                    <Button onClick={() => setEdit({ modal: true, ...row })} startIcon={<EditIcon />}>
                      Rediger
                    </Button>
                    <Tooltip
                      title="Trykk igjen for å slette"
                      open={deleteBtn.index === index}
                      placement="right"
                      arrow
                      disableHoverListener
                    >
                      <Button
                        size="small"
                        color={deleteBtn.index === index ? 'error' : 'info'}
                        onClick={() => deletePlaytime(index, row)}
                        startIcon={<DeleteIcon />}
                      >
                        Slett
                      </Button>
                    </Tooltip>
                  </Stack>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <EditModal editState={{ edit, setEdit }} />
    </div>
  );
};

export default MyHours;
